module.exports = __webpack_public_path__ + "static/media/home-slider-banner-3.0b271365.png";